import { OrdersShowLogsIdField } from 'pages/Orders/OrdersShow/OrdersShowLogs/OrdersShowLogsIdField/OrdersShowLogsIdField';
import { useRecordContext, useTranslate } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { TableBody, TableCell, TableHead, TableRow } from 'shared/mui/Table';
import { JsonField } from 'shared/react-admin/Fields';

import { StyledBox, StyledJsonBox, StyledTable } from './OrdersShowLogsExpand.styled';
import { OrdersShowLogsExpandCopyButton } from './OrdersShowLogsExpandCopyButton';

export const OrdersRequestLogsExpand = (): JSX.Element => {
  const record = useRecordContext();
  const translate = useTranslate();

  const responseStatus = record?.responseData?.statusCode;

  return (
    <Box>
      <StyledBox>
        <OrdersShowLogsIdField />
      </StyledBox>
      {Boolean(responseStatus) && (
        <StyledTable>
          <TableHead>
            <TableRow>
              <TableCell>
                <OrdersShowLogsExpandCopyButton
                  label={translate('app.orders.logs.request')}
                  source="requestData"
                />
              </TableCell>
              <TableCell>
                <OrdersShowLogsExpandCopyButton
                  label={translate('app.orders.logs.response')}
                  source="responseData"
                />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <StyledJsonBox>
                  <JsonField source="requestData" />
                </StyledJsonBox>
              </TableCell>
              <TableCell>
                <StyledJsonBox>
                  <JsonField source="responseData" />
                </StyledJsonBox>
              </TableCell>
            </TableRow>
          </TableBody>
        </StyledTable>
      )}
    </Box>
  );
};
